import ActivityJson from "../json/Activity.json";
import ChartAreaJson from "../json/ChartArea.json";
import DealerJson from "../json/Dealers.json";
import GearJson from "../json/Gear.json";
import OperatorsJson from "../json/Operators.json";
import PermitsJson from "../json/Permits.json";
import PortJson from "../json/Port.json";
import SpeciesJson from "../json/Species.json";
import TripTypesJson from "../json/TripTypes.json";
import ReportTripTypeJson from "../json/ReportTripType.json";
import UomJson from "../json/Uom_codes.json";
import packageJson from "../../package.json";

const eVtrDB = {
  name: "eVtrDB",
  version: 16,
  stores: [
    {
      name: "activity",
      key: "KEY",
      config: { keyPath: "KEY" },
      visible: true,
      storeData: ActivityJson,
    },
    {
      name: "tripType",
      key: "KEY",
      visible: true,
      config: { keyPath: "KEY" },
      storeData: TripTypesJson,
    },
    {
      name: "chartArea",
      key: "AREA_CODE",
      visible: true,
      config: { keyPath: "AREA_CODE" },
      storeData: ChartAreaJson,
    },
    {
      name: "dealers",
      key: "DEALER_PERMIT_NUMBER",
      visible: true,
      config: { keyPath: "DEALER_PERMIT_NUMBER" },
      storeData: DealerJson,
    },
    {
      name: "gear",
      key: "CODE",
      visible: true,
      config: { keyPath: "CODE" },
      storeData: GearJson,
    },
    {
      name: "permit",
      key: "PNUM",
      visible: true,
      config: { keyPath: "PNUM" },
      storeData: PermitsJson,
    },
    {
      name: "port",
      key: "ID",
      visible: true,
      config: { keyPath: "ID" },
      storeData: PortJson,
    },
    {
      name: "species",
      key: "SPPCODE",
      visible: true,
      config: { keyPath: "SPPCODE" },
      storeData: SpeciesJson,
    },
    {
      name: "operator",
      key: "OPERATOR_KEY",
      visible: true,
      config: { keyPath: "OPERATOR_KEY" },
      storeData: OperatorsJson,
    },
    {
      name: "version",
      key: "VERSION_NBR",
      visible: false,
      config: { keyPath: "VERSION_NBR" },
      storeData: [
        {
          VERSION_NBR: packageJson.version,
        },
      ],
    },
    {
      name: "timestamp",
      key: "id",
      visible: true,
      config: { keyPath: "id" },
      storeData: {
        id: 0,
        Dealers_1620842192: 1620842192,
        Operators_1620842192: 1620842192,
        Permits_1620842192: 1620842192,
        Species: 1620842192,
        Gear: 1470316963,
        ChartArea: 1471980769,
        Port: 1512678668,
        Uom_codes: 1470316963,
      },
    },
    {
      name: "users",
      key: "username",
      visible: false,
      config: { keyPath: "id", autoIncrement: true },
      storeData: [],
    },
    {
      name: "reportType",
      key: "KEY",
      visible: true,
      config: { keyPath: "KEY" },
      storeData: [
        { VALUE: "OTHER", KEY: 1 },
        { VALUE: "LOBSTER", KEY: 2 },
        { VALUE: "CLAM", KEY: 3 },
      ],
    },
    {
      name: "reportTripType",
      key: "SORT_KEY",
      visible: true,
      config: { keyPath: "KEY" },
      storeData: ReportTripTypeJson,
    },
    {
      name: "uomCodes",
      key: "uom_codes",
      visible: true,
      config: { keyPath: "uom_codes" },
      storeData: UomJson,
    },
  ],
};

export default eVtrDB;
